import { PostsType } from '../../helpers/constants';

export const getBlogTitle = (type: PostsType, title?: string): string => {
  if (type === 'all' || !title) {
    return 'Fishbrain blog';
  }
  if (type === 'author') {
    return `Posts by ${title}`;
  }
  if (type === 'species') {
    return `Posts about ${title}`;
  }
  return title;
};
